module.exports = __webpack_public_path__ + "static/clerical-9ff24d51734401b017a57b5fddb4654c.jpg";